import type { TicketAttendanceStatus } from '@/types/TicketAttendanceStatus';

export const ticketAttendanceLabels: Record<TicketAttendanceStatus, string> = {
  not_checked_in: 'Not checked in',
  checked_in: 'Checked in',
  no_show: 'No show',
  cancelled: 'Cancelled',
};

export const ticketAttendanceSelectOptions: {
  value: TicketAttendanceStatus;
  label: string;
}[] = (
  Object.entries(ticketAttendanceLabels) as [TicketAttendanceStatus, string][]
).map(([value, label]) => ({ value, label }));
